import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

window.Pusher = Pusher;

const reverbScheme = import.meta.env.VITE_REVERB_SCHEME ?? 'http';
const reverbPort   = parseInt(import.meta.env.VITE_REVERB_PORT ?? '8080');
const reverbHost   = import.meta.env.VITE_REVERB_HOST ?? window.location.hostname;
// Production uses Nginx reverse-proxy at /app; local direct Reverb uses no path
const reverbPath   = import.meta.env.VITE_REVERB_PATH ?? '';
const useTLS       = reverbScheme === 'https';

window.Echo = new Echo({
    broadcaster: 'reverb',
    key: import.meta.env.VITE_REVERB_APP_KEY,
    wsHost: reverbHost,
    wsPort: reverbPort,
    wssPort: reverbPort,
    forceTLS: useTLS,
    enabledTransports: ['ws', 'wss'],
    enableLogging: true,
    path: reverbPath,
    auth: {
        headers: {
            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content'),
        },
    },
});

console.log('Echo initialised', { host: reverbHost, port: reverbPort, scheme: reverbScheme, path: reverbPath || '(none)', key: import.meta.env.VITE_REVERB_APP_KEY ? '***' : 'NOT SET' });